<!--
  --
  -- ヘルパーテキストを表示するクラス
  --
  -- 2つの使い方を提供する。
  -- (1) <c-helper-text>テキスト文</c-helper-text>
  -- (2) <c-helper-text :messages="['1行目', '2行目']">
  --
  -- 表示するテキストに改行があれば、表示も改行する。
  --
  -->
<template>
  <div
    class="caption whitespace-pre-wrap"
    :class="classes"
  >
    <slot>{{texts}}</slot>
  </div>
</template>

<script>
export default {
  name: 'CHelperText',
  props: {
    /**
     * 表示テキスト
     */
    messages: {
      type: [String, Array],
      default: ''
    },

    /**
     * 警告色で表示する
     */
    warn: {
      type: Boolean,
      default: false
    },

    /**
     * エラー色で表示する
     */
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      if (this.error) {
        return 'error--text'
      } else if (this.warn) {
        return 'warning--text'
      }
      return ''
    },

    texts () {
      return Array.isArray(this.messages)
        ? this.messages.join('\n')
        : this.messages
    }

  }
}
</script>
